export default __webpack_public_path__ + "static/media/09.23.25 Minutes Reg Mtg.78ebc392.pdf";